import React, { Component } from 'react';
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import AppLogo_white from '../../images/AppLogo_white.jpeg'
import LoginForm_sideImage from '../../images/LoginForm_sideImage.jpg'


const mapStateToProps = (store)=>{
  return store
}

const mapDispatchToProps = (dispatch)=>{
  return{
    ShowAlert : (Settings)=> {dispatch({type:"UpdateAlert",payload:Settings})},
    ShowLoader:(Isloading)=> {dispatch({type:"UpdateLoader",payload:Isloading})},
  }
}

class Resetpassword extends Component {
constructor(props) {
  super(props);
  this.state = {
    isTokenValidStatus: 0,
    UserId:0       
  };
}

render(){

return(

<div class="login_Container">

  <div class="side_Image">
    <img src={LoginForm_sideImage} />
  </div>
    
    <form class="login_form" onSubmit={this.SubmitForm} novalidate>

      <div class="loginform_logo"><img src={AppLogo_white} /></div>
        
        <div class="loginform_Content" hidden={this.state.isTokenValidStatus==1?false:true}>
            <p>Welcome,</p>
            <p>Please enter new password to reset.</p>
        </div>

        <div class="loginform_form row" hidden={this.state.isTokenValidStatus==1?false:true}>

            <div class="formInput_Container col-md-6 col-lg-6 col-12">
                <label for=""><span style={{color:"red"}}>* </span>New Password</label>
                <input autocomplete="off" type="password" class="form-control" id="ResetPassword_Password" autoFocus required/>
            </div>

            <div class="formInput_Container col-md-6 col-lg-6 col-12">
                <label for=""><span style={{color:"red"}}>* </span>Confirm New Password</label>
                <input autocomplete="off" type="password" class="form-control" id="ResetPassword_ConfirmPassword" required/>
            </div>

        </div>

        <div class="loginform_footer" hidden={this.state.isTokenValidStatus==1?false:true}>
            <button type="submit" class="btn btn_style1">Submit</button>
        </div>

      <h2 style={{marginTop:"30px"}} hidden={this.state.isTokenValidStatus==2?false:true}>Token is not valid or expired</h2>

    </form>

</div>

)}
componentDidMount(){
  this.CheckTokenValidation()
}
CheckTokenValidation=()=>{

  var url_string = window.location.href
  var url = new URL(url_string);           
  var UserId = url.searchParams.get("Keyval1");
  var Oldpassword = url.searchParams.get("Keyval2");
  this.setState({
    UserId:UserId
  })

  this.props.ShowLoader({Isloading:true})
  var Parameters={
    UserId: UserId,
    OldPassword: Oldpassword
  }
  Common.Ajax("","Get",false,Common.APILinks.ValidateRecoverPasswordToken,Parameters,(resp)=>{  
    this.props.ShowLoader({Isloading:false})
    if(resp.status==true)
    {
      this.setState({
        isTokenValidStatus: resp.tokenValidationStatus ? 1 : 2
      })               
    }
    else
    {
      this.props.ShowAlert({Type:0,Msg:resp.message })
      setTimeout(()=>{ $("#Alertmsgbtn").click()}, 50);
    }
  },
  (error)=>{
      this.props.ShowLoader({Isloading:false})
      this.props.ShowAlert({Type:0,Msg:"Something went wronge, please try again."})
      setTimeout(()=>{ $("#Alertmsgbtn").click()}, 50); 
  }
)

}
SubmitForm=(e)=>{
  e.preventDefault()
  if($("#ResetPassword_Password").val() != $("#ResetPassword_ConfirmPassword").val())
  {
    this.props.ShowAlert({Type:0,Msg: "New password does not match with confirm password"})
    setTimeout(function(){ $("#Alertmsgbtn").click()}, 50);
    return
  }
  this.props.ShowLoader({Isloading:true})
  var Parameters={
    UserId: this.state.UserId,
    Newpassword: $("#ResetPassword_Password").val(),
  }
  Common.Ajax("","Get",false,Common.APILinks.ResetPassword,Parameters,(resp)=>{  
    this.props.ShowLoader({Isloading:false})
    if(resp.status==true)
    {
      this.props.ShowAlert({Type:1,Msg:"Password updated successfully" })
      setTimeout(()=>{ $("#Alertmsgbtn").click()}, 50);
      this.props.history.push("/Login")
    }
    else
    {
      this.props.ShowAlert({Type:0,Msg:resp.message })
      setTimeout(()=>{ $("#Alertmsgbtn").click()}, 50);
    }
  },
  (error)=>{
      this.props.ShowLoader({Isloading:false})
      this.props.ShowAlert({Type:0,Msg:"Something went wronge, please try again."})
      setTimeout(()=>{ $("#Alertmsgbtn").click()}, 50); 
  }
  )

}


}


export default connect( mapStateToProps,mapDispatchToProps )(Resetpassword);
